import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.jpeg";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <br/>
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="blue">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col md={1}></Col>
          <Col
            md={3}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <br/>
        <br/>
        <h1 className="project-heading">
          Professional <strong className="blue">Skillset </strong>
        </h1>

        <br/>
        <br/>
        <Techstack />
        <br/>
        <br/>
        <h1 className="project-heading">
          <strong className="blue">Tools</strong> I use
        </h1>
        <br/>
        <br/>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
